import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Creates a Payments.lk hosted checkout session via the SoloWay backend
 * @param {Object} params
 * @param {string} params.bookingType - 'hotel', 'tour', 'visa', 'event'
 * @param {number|string} params.bookingId - Primary ID of booking
 * @param {string} [params.clientType] - 'web' | 'mobile'
 */
const createPaymentsLkCheckout = async ({ bookingType, bookingId, clientType = 'web', quantity = 1, isAdvance = false }) => {
    const token = localStorage.getItem('jwt_token') || localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    const response = await axios.post(
        `${API_URL}/payment/payments-lk/create-checkout`,
        { bookingType, bookingId, clientType, quantity, isAdvance },
        { headers }
    );
    return response.data;
};

/**
 * Queries authoritative payment status for a Payments.lk transaction reference
 * @param {string} reference - Order reference e.g. PLK_HOTEL_123_...
 */
const getPaymentsLkStatus = async (reference) => {
    const token = localStorage.getItem('jwt_token') || localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    const response = await axios.get(
        `${API_URL}/payment/payments-lk/status/${encodeURIComponent(reference)}`,
        { headers }
    );
    return response.data;
};

const PaymentService = {
    createPaymentsLkCheckout,
    getPaymentsLkStatus,
};

export default PaymentService;

